var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"trigger":"hover","placement":_vm.placement,"offset":_vm.offset,"width":_vm.width}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"name-wrapper cell",staticStyle:{"width":"100%"},attrs:{"slot":"reference"},slot:"reference"},[(_vm.$slots.content)?_vm._t("content"):_c('span',[_vm._v(_vm._s(_vm._contant))])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5386e444","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopoverTabs.vue
// module id = null
// module chunks = 